// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2rn25","tab":"Tabs_tab__rKX1O","tabActive":"Tabs_tabActive__2-qZV"};